  <!-- Filtros de tiempo -->
  <div class="card p-3">

    <!-- Botones de filtro + botón de precio -->
    <div class="filter-buttons d-flex flex-wrap gap-2">
      <button class="btn btn-outline-light btn-with-sm" [class.active]="activeFilter === 'today'" (click)="onFilterChange('today')"> {{"today" |
        translate }} </button>
      <button class="btn btn-outline-light btn-with-sm" [class.active]="activeFilter === '7days'" (click)="onFilterChange('7days')">
        7 {{ "days" | translate }}</button>
      <button class="btn btn-outline-light btn-with-sm" [class.active]="activeFilter === '30days'" (click)="onFilterChange('30days')">
        30 {{ "days" | translate }}</button>


      <!-- Botón MES con dropdown -->
      <div class="position-relative">
        <button class="btn btn-outline-light btn-with-sm" [class.active]="activeFilter === 'month'" (click)="toggleMonthDropdown()">

          <!-- Texto dinámico -->
          {{ selectedMonthLabel ? (selectedMonthLabel | translate) : ('month' | translate) }}

          <!-- Flecha -->
          <i class="fas fa-caret-down ms-1"></i>
        </button>

        <!-- Menú desplegable -->
        <ul class="dropdown-menu show" *ngIf="showMonthDropdown"
          style="position: absolute; top: 100%; left: 0; z-index: 1000;">
          <li class="dropdown-item" *ngFor="let m of months" (click)="selectMonth(m.index)">
            {{ m.label | translate }}
          </li>
        </ul>
      </div>



      <!-- <button class="btn btn-outline-light btn-with-sm" [class.active]="activeFilter === 'month'" (click)="onFilterChange('month')">
          {{ "currentMonth" | translate}} </button> -->
      <button class="btn btn-outline-light btn-with-sm" [class.active]="activeFilter === 'currentYear'" (click)="onFilterChange('currentYear')">
        {{ "Año actual" | translate}} </button>
      <button class="btn btn-outline-light btn-with-sm" [class.active]="activeFilter === 'previousYear'"
        (click)="onFilterChange('previousYear')">
        {{ "Año anterior" | translate}} </button>
      <button class="btn btn-outline-light btn-with-sm" [class.active]="activeFilter === 'custom'" (click)="onFilterChange('custom')"> {{
        "customize" | translate }} </button>

      <button class="btn btn-outline-light btn-with-sm ms-auto" *ngIf="showPriceFilter" [class.active]="showPriceInput" (click)="showPriceInput = !showPriceInput">
        {{ "pricekwh" | translate }}: {{ priceKwh | number:'1.2-2' }}
      </button>
    </div>


    <!-- Grupo de inputs debajo -->
    <!-- Inputs de filtros adicionales -->
    <div class="d-flex justify-content-between align-items-start flex-wrap">

      <div style="min-width: 300px;">
        <div class="d-flex gap-3 mt-2" *ngIf="activeFilter === 'custom'">
          <div class="date-input d-flex flex-column">
            <label> {{ "startDay" | translate }} :</label>
            <input type="date" [(ngModel)]="customStartDate" (change)="onCustomDateChange()">
          </div>
          <div class="date-input d-flex flex-column">
            <label> {{"endDay" | translate }}:</label>
            <input type="date" [(ngModel)]="customEndDate" (change)="onCustomDateChange()">
          </div>
        </div>
      </div>

      <div class="date-input d-flex flex-column align-items-end" *ngIf="showPriceInput && showPriceFilter">
        <label>€/kWh:</label>
        <input type="number" [(ngModel)]="priceKwh" class="form-control" step="0.01" style="min-width: 120px;"
          (change)="savePrice()">
      </div>

    </div>
  </div>
